<template>
  <div class="Installation-process">
    <div
      class="activate-home"
      v-for="i in noOrderImgSrc"
      :key="i.vulae"
    >
      <img
        class="activate-img"
        :src="i.imgUrl"
        alt
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
  },
  data () {
    return {
      noOrderImgSrc: [
        {
          imgUrl: require('../assets/images/OBUNoOrder/OBUNoOrder_01.png'),
          stepImgUrl: "",
          value: 1
        },
        {
          imgUrl: require('../assets/images/OBUNoOrder/OBUNoOrder_02.png'),
          stepImgUrl: "",
          value: 2
        },
        {
          imgUrl: require('../assets/images/OBUNoOrder/OBUNoOrder_03.png'),
          stepImgUrl: "",
          value: 3
        },
        {
          imgUrl: require('../assets/images/OBUNoOrder/OBUNoOrder_04.png'),
          value: 4
        },
        {
          imgUrl: require('../assets/images/OBUNoOrder/OBUNoOrder_05.png'),
          value: 5
        },
        {
          imgUrl: require('../assets/images/OBUNoOrder/OBUNoOrder_06.png'),
          value: 6
        },
        // {
        //   imgUrl: require('../assets/images/OBU激活主页/OBU激活主页_01.png')
        // }
      ]
    }
  },
  computed: {
  },
  created () {
  },
  mounted () {
  },
  watch: {
  },
  methods: {
  },
  components: {
  }
}
</script>
<style scoped lang="scss">
.activate-home {
  position: relative;
  .activate-img {
    width: 100%;
    height: 100%;
  }
}
</style>